<template>
  <div class="textbook-encyclopedia">
    <div class="close-button">
      <i
        data-io-click="tracker"  @click="closeTextbookEncyclopediaDialog"
        class="el-dialog__close el-icon el-icon-close"
      ></i>
    </div>
    <iframe
      id="frame"
      :src="iframeUrl"
      style="
        height: 100%;
        width: 497px;
        border: 1px solid #dedede;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 6px 20px 0px;
      "
    ></iframe>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "TextbookEncylopedia",
  data() {
    return {
      iframeUrl: "https://ai.xkw.com/tools/textbook-encyclopedia?source=wxt",
    };
  },
  computed: {
    ...mapState({
      currentCourse: "currentCourse",
      currentTextbook: "currentTextbook",
    }),
  },
  methods: {
    closeTextbookEncyclopediaDialog() {
      this.$emit("closeTextbookEncyclopediaDialog", null);
    },
    updateIframeUrl() {
      // console.log(this.currentCourse)
      // console.log(this.currentTextbook)
      if (this.currentCourse.stageId && this.currentCourse.stageId != null) {
        this.iframeUrl =
          this.iframeUrl + "&stageId=" + this.currentCourse.stageId;
      }
      if (
        this.currentCourse.subjectId &&
        this.currentCourse.subjectId != null
      ) {
        this.iframeUrl =
          this.iframeUrl + "&subjectId=" + this.currentCourse.subjectId;
      }
      if (this.currentCourse.courseId && this.currentCourse.courseId != null) {
        this.iframeUrl =
          this.iframeUrl + "&courseId=" + this.currentCourse.courseId;
      }
      if (
        this.currentTextbook.versionId &&
        this.currentTextbook.versionId != null &&
        this.currentTextbook.versionId != 2
      ) {
        this.iframeUrl =
          this.iframeUrl + "&versionId=" + this.currentTextbook.versionId;
      }
      if (this.currentTextbook.bookId) {
        this.iframeUrl =
          this.iframeUrl + "&textbookId=" + this.currentTextbook.bookId;
      } else {
        this.iframeUrl =
          this.iframeUrl + "&textbookId=" + this.currentTextbook.id;
      }
      // console.log(this.iframeUrl)
    },
  },
  mounted() {
    this.updateIframeUrl();
  },
  watch: {
    currentCourse(newVal, oldVal) {
      //高中地理为34，，
      let courseId = 34;
      //教材百科只在高中地理展示，当用户切换课程时，关闭教材百科侧边栏
      if (newVal.courseId != courseId) {
        this.closeTextbookEncyclopediaDialog();
      }
    },
    currentTextbook(newVal, oldVal) {
      this.iframeUrl =
        "https://ai.xkw.com/tools/textbook-encyclopedia?source=wxt";
      this.updateIframeUrl();
    },
    //切换不同左侧菜单时，关闭教材百科
    $route(to, from) {
      // 对路由变化做出响应
      // console.log(from.path)
      // console.log('路由变化了：', to.path);
      if (from.path != to.path) {
        this.closeTextbookEncyclopediaDialog();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.close-button {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;

  &:hover {
    color: #2b7eff;
  }
}

.textbook-encyclopedia {
  height: 102%;
  width: 484px;
  position: fixed;
  right: 0;
  z-index: 9999;
  top: 0;
}
</style>
